import React, {Component} from 'react';
import {connect} from 'react-redux';
import {withRouter} from 'react-router-dom';
import {identityServiceStart} from '@riotgames/kr-identity-sdk';
import './identification.scss';

const doOnSuccessIdentification = (data, nextUrl, history) => {
  history.push(`${nextUrl}?identityToken=${data.identityToken}`);
};

const doOnFailIdentification = data => alert('본인인증에 실패했습니다. 다시 한번 시도해 주세요.', data);

export const openIdentificationPopup = (e, nextUrl, history) => {
  e.preventDefault();

  identityServiceStart(
    `${ENV}` === 'PROD' ? 'PC_BANG_OWNERS_SITE_PROD' : 'INTERNAL_DEMO',
    data => doOnSuccessIdentification(data, nextUrl, history),
    data => doOnFailIdentification(data),
    `${ENV}` === 'PROD' ? {environment: 'prod'} : {environment: 'development'}
  );
};

class Identification extends Component {
  render() {
    return (
      <div className="identification">
        <div className="next-btn" onClick={e => openIdentificationPopup(e, this.props.nextUrl, this.props.history)}>
          <div className="big-text">본인 인증</div>
        </div>
      </div>
    );
  }
}

export default withRouter(connect()(Identification));
